import { useCallback, useMemo } from 'react';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';
export const useReportSeries = (columns, defaultSeries) => {
    const [seriesParam, setSeriesParam] = useQueryParam('series', withDefault(StringParam, undefined));
    const availableColumns = useMemo(() => {
        return columns.filter((column) => ['money', 'number'].includes(column.type));
    }, [columns]);
    const availableSeries = useMemo(() => {
        return availableColumns.map((column) => column.id);
    }, [availableColumns]);
    const activeSeries = useMemo(() => {
        if (seriesParam === undefined) {
            return defaultSeries;
        }
        const isValidSeries = availableSeries.includes(seriesParam);
        if (isValidSeries) {
            return seriesParam;
        }
        return defaultSeries;
    }, [seriesParam, availableSeries, defaultSeries]);
    const setActiveSeries = useCallback((newSeries) => {
        if (newSeries === undefined) {
            setSeriesParam(undefined);
            return;
        }
        if (availableSeries.includes(newSeries)) {
            setSeriesParam(newSeries);
        }
    }, [setSeriesParam, availableSeries]);
    const headerOptions = useMemo(() => {
        return availableColumns
            .map((column) => {
            if (activeSeries === column.id) {
                return;
            }
            return {
                value: column.id,
                label: String(column.label),
            };
        })
            .filter(Boolean);
    }, [availableColumns, activeSeries]);
    return {
        activeSeries,
        setActiveSeries,
        headerOptions,
    };
};
